import { useEffect, useState } from 'react';

/**
 * Returns true when the viewport is at most `breakpoint` px wide (phone-sized).
 *
 * Inline styles can't use CSS `@media`, so components read this hook and swap
 * style objects in JS. It tracks live viewport changes (resize / rotate) via
 * `matchMedia` so the layout stays correct without a reload.
 */
export function useIsMobile(breakpoint = 640): boolean {
  const query = `(max-width:${breakpoint}px)`;
  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
